// Hooplandia Widgets

import cardWidgetQuickLinks from './js/widgets/cardWidgetQuickLinks.js';
import cardWidgetLogoDates from './js/widgets/cardWidgetLogoDates.js';
import videoWidget from './js/widgets/videoWidget.js';
import cardWidgetCountdownImg from './js/widgets/cardWidgetCountdownImg.js';
import cardWidgetExploreButtons from './js/widgets/cardWidgetExploreButtons.js';
import cardWidgetMoreBigE from './js/widgets/cardWidgetMoreBigE.js';
import cardWidgetLineup from './js/widgets/cardWidgetLineup.js';
import cardWidgetFooterLogoSlogan from './js/widgets/cardWidgetFooterLogoSlogan.js';
import cssSponsors from './js/widgets/cssSponsors.js';

import './js/siteInfoBanner.js';
import microModal from './js/microModal';
// Custom theme scripts

import './js/localjs.js';

import { themeController } from './js/subpages/themeController.js';

// Initialize Hooplandia widgets

$(document).ready(function () {
  microModal();
  setTimeout(() => {
    $('.header').css('opacity', '1');
  }, 200);

  themeController();
});

// Initialize homepage widgets
if (window.location.pathname === '/') {
  const isBigE = $('body').hasClass('theBigE');
  $(document).ready(function () {
    
    if (isBigE) {
      cardWidgetCountdownImg();
      cardWidgetExploreButtons();
      cardWidgetMoreBigE();
      cardWidgetLineup();
      cssSponsors();
    }
  });
  
  $(window).load(function () {
    if (isBigE) {
      videoWidget();
    }
  });
}

// Initialize site-wide widgets
$(document).ready(function () {
  if (!$('body').hasClass('hooplandiaTheme')) {
    cardWidgetQuickLinks();
    cardWidgetLogoDates();
    cardWidgetFooterLogoSlogan();
  }
});
